module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_3016.b9ad890e.png";